import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { uiRequestOverlayReset, printDataUpdateRequest, printDataPdfRequest, printDataPdfReset, updateFlyerSettings } from '../../../actions'
import PrintFlyer from '../present/PrintFlyer'
import { CLI_CURRENT_CINEMA_ID, FEATURES, FLYER_DATA, UI_GENERAL  } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'



const mapDispatchToProps = (dispatch, ownProps) => ({
    printFlyerRequest: (printFormatState, printFormat, landscape, activeWeek, printType, cinemaId) => {
      dispatch(printDataPdfRequest(printFormatState, printFormat, landscape, activeWeek, printType, cinemaId))
    },
    printUpdateRequest: () => {
      dispatch(printDataUpdateRequest())
    },
    updateFlyerSettings: (payload) => {
      dispatch(updateFlyerSettings(payload))
      dispatch(printDataUpdateRequest())
    },
    onPrintFlyerPdfResetState: () => {
      dispatch(printDataPdfReset())
      dispatch(uiRequestOverlayReset())
    }
})

const mapStateToProps = state => ({
    requestOverlay: getData(state, [UI_GENERAL, 'requestOverlay']),
    features: getData(state, FEATURES),
    flyerData: getData(state, FLYER_DATA),
    // currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID) //ToDO Testen
})


const PrintFlyerContainer = ({
  params,
  features,
  flyerData,
  printFlyerRequest, 
  printUpdateRequest,
  requestOverlay,
  basicUrl,
  closePagePath,
  onPrintFlyerPdfResetState,
  // currentCinemaId,
  updateFlyerSettings
}) => {
  const { cinemaId, printType, printFormat, landscape, week } = params
  const { hasChanges, error, status, flyerSettings } = flyerData

  return (
    <PrintFlyer 
        printType={printType} 
        updateFlyerSettings={updateFlyerSettings} 
        flyerSettings={flyerSettings} 
        cinemaId={cinemaId}
        printID={printFormat}
        landscape={landscape} 
        requestStatus={status}
        requestError={error}
        requestOverlay={requestOverlay}
        activeWeek={week}
        hasChanges={hasChanges}
        features={features}
        // currentCinemaId={cinemaId}
        flyerData={flyerData}
        basicUrl={basicUrl}
        closePagePath={closePagePath}
        printFlyerRequest={printFlyerRequest} 
        printUpdateRequest={printUpdateRequest}
        onPrintFlyerPdfResetState={onPrintFlyerPdfResetState}
      />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PrintFlyerContainer)


